<template>
  <div class="payment-complete">
<h1 v-if="loading">🔄 Checking Payment Status...</h1>
<div v-if="loading" class="spinner"></div>

    <h1 v-else-if="result === 'success'">✅ Payment Successful</h1>
    <h1 v-else-if="result === 'failed'">❌ Payment Failed</h1>
    <h1 v-else>ℹ️ Payment Status Unknown</h1>

    <p v-if="!loading && result === 'success'">
      <span v-if="subscriptionDays">
        You've activated a <strong>{{ subscriptionDays }}-day subscription</strong> on your account.
      </span> <template v-else-if="lcCreditsEarned">
    You've added <strong>{{ lcCreditsEarned }} LinkCheck credit{{ lcCreditsEarned !== 1 ? 's' : '' }}</strong>.
    Your LinkCheck balance is now <strong>{{ lcCurrentBalance }}</strong>.
  </template>
<span v-else>
  You've successfully added <strong>{{ creditsEarned }} credits</strong> to your account.
  Your new balance is <strong>{{ currentBalance }} credits</strong>.
</span>


    </p>

    <p v-else-if="!loading && result === 'failed'">
      Your payment attempt did not go through. You can try again or contact support.
    </p>
    <p v-else-if="!loading">
      We couldn't determine the result of your payment. You may need to refresh or try again.
    </p>

    <div class="summary" v-if="!loading">
      <h3>Next Steps</h3>
      <ul>
     <li v-if="result === 'success' && lcCreditsEarned">
  ➡️ You can now run <strong>LinkCheck</strong> to test tx ↔ address relationships.
</li>
<li v-else-if="result === 'success'">
  ➡️ You can now use <strong>Pathtracer</strong> to analyze your transaction hashes.
</li>
        <li>➡️ Review your balance on <strong>My Account</strong>.</li>
        <li v-if="result !== 'success'">➡️ Try again to complete your payment.</li>
        <li>📬 Contact support if you believe something went wrong.</li>
      </ul>
    </div>

    <div class="button-group" v-if="!loading">
  <!-- Primary CTA switches based on what was purchased -->
  <router-link
    v-if="result === 'success' && purchasedLinkCheck"
    class="button primary"
    :to="{ path: '/linkchecktool' }"
    data-track="payment_complete_open_linkcheck">
    Open LinkCheck
  </router-link>

  <router-link
    v-else-if="result === 'success'"
    class="button primary"
    :to="{ name: 'AnalysisTool' }"
    data-track="payment_complete_use_tool">
    Use PathTracer Now
  </router-link>

  <!-- If both were purchased, offer the other tool as a secondary button -->
  <router-link
    v-if="result === 'success' && purchasedLinkCheck && creditsEarned > 0"
    class="button"
    :to="{ name: 'AnalysisTool' }"
    data-track="payment_complete_use_pathtracer">
    Use PathTracer
  </router-link>

  <router-link
    v-else-if="result === 'success' && !purchasedLinkCheck && lcCreditsEarned > 0"
    class="button"
    :to="{ path: '/linkcheck' }"
    data-track="payment_complete_open_linkcheck_secondary">
    Open LinkCheck
  </router-link>

  <!-- Always offer Account + Try Again (if failed) -->
  <router-link class="button" :to="{ name: 'AccountPage' }" data-track="payment_complete_my_account">
    Go to My Account
  </router-link>

  <router-link
    class="button"
    :to="{ name: 'StripeProductChooser' }"
    v-if="result !== 'success'"
    data-track="payment_complete_try_again">
    Try Again
  </router-link>
</div>

  </div>
</template>


<script>
export default {
  name: 'PaymentCompletePage',
data() {
  return {
    result: '',
    creditsEarned: 0,
    subscriptionDays: 0,
    currentBalance: 0,
    loading: true, // NEW
    lcCreditsEarned: 0,
    lcCurrentBalance: 0,
  };
},
computed: {
  purchasedLinkCheck() {
    return Number(this.lcCreditsEarned || 0) > 0;
  }
}
,
created() {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const sessionId = hashParams.get('session_id');

  if (sessionId) {
    fetch('https://www.pathtracer.io/api/stripe/verify_checkout_session_live.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ session_id: sessionId })
    })
    .then(res => res.json())
.then(data => {
  if (data.status === 'success') {
    this.result = 'success';
    this.creditsEarned = data.creditsPurchased || 0;
    this.subscriptionDays = data.subscriptionPurchased || 0;
    this.currentBalance = data.currentCreditBalance || 0;
    // NEW
    this.lcCreditsEarned  = data.linkcheckPurchased || 0;
    this.lcCurrentBalance = data.linkcheckCurrentBalance || 0;
  } else {
    this.result = 'failed';
  }
})
    .catch(() => {
      this.result = 'failed';
    })
    .finally(() => {
      this.loading = false;
    });
  } else {
    this.result = 'failed';
    this.loading = false;
  }
}

};
</script>

<style scoped>
.payment-complete {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 20px;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
h1 {
  margin-bottom: 16px;
}
.summary {
  text-align: left;
  margin: 24px auto;
  max-width: 460px;
}
.summary ul {
  list-style-type: none;
  padding-left: 0;
}
.summary li {
  margin: 10px 0;
}
.button-group {
  margin-top: 24px;
}
.button {
  display: inline-block;
  margin: 10px;
  padding: 12px 24px;
  background-color: #3498db;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.2s;
}
.button.primary {
  background-color: #2ecc71;
}
.button.primary:hover {
  background-color: #27ae60;
}
.button:hover {
  background-color: #2980b9;
}
.spinner {
  margin: 20px auto;
  width: 48px;
  height: 48px;
  border: 5px solid #ccc;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
